(() => {
  const currentParams = new URLSearchParams(window.location.search);
  const activeTheme = window.Shopify?.theme;
  const previewThemeId =
    currentParams.get('preview_theme_id') ||
    (activeTheme?.role && activeTheme.role !== 'main' ? String(activeTheme.id || '') : '');
  if (!previewThemeId) return;

  const previewKeys = ['preview_theme_id', 'pb', '_fd', '_sc'];

  const preservePreviewContext = (scope = document) => {
    scope.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (!/^\/(?:collections\/[^/]+\/)?products\/[^/]+\/?$/i.test(url.pathname)) return;

      previewKeys.forEach((key) => {
        const value = key === 'preview_theme_id' ? previewThemeId : currentParams.get(key);
        if (value && !url.searchParams.has(key)) url.searchParams.set(key, value);
      });

      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  };

  preservePreviewContext();
  document.addEventListener('shopify:section:load', (event) => {
    preservePreviewContext(event.target);
  });
})();
